<template>
    <base-dialog max-width="300px" ref="base">
        <v-card min-height="80vh">
            <v-card-title>Подписка на сайт</v-card-title>
            <v-card-subtitle v-html="subtitle"></v-card-subtitle>
            <v-card-text>
                <div>{{ text }}</div>
                <br/>
                <v-container fluid>
                    <v-row align="center">
                        <v-col style="max-width: 50px" class="text-left px-0">
                            <v-btn @click="count === 1 ? undefined : count -= 1" style="font-size: 20px" small
                                   elevation="1" fab>-
                            </v-btn>
                        </v-col>
                        <v-col class="text-center px-0">
                            <h1>{{ count }} мес.</h1>
                        </v-col>
                        <v-col style="max-width: 50px" class="text-right px-0">
                            <v-btn @click="count += 1" style="font-size: 20px" small elevation="1" fab>+</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <h1 class="text-center">Итого {{ count * SHOP_PRICE }}₽</h1>
                <br/>
                <div>
                    <v-form ref="form" lazy-validation v-model="valid">
                        <v-text-field
                            ref="email"
                            outlined
                            dense
                            label="Электронная почта"
                            v-model.trim="customerEmail"
                            @input="error_message = ''"
                            :error-messages="error_message"
                        />
                    </v-form>
                </div>
                <div>
                    <v-btn :loading="loading" @click="startPay" class="btn" color="success" block>ПРОДЛИТЬ</v-btn>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-container fluid class="py-0">
                    <v-row>
                        <v-col cols="12" class="pb-1 pt-2 text-right">
                            <v-btn width="108" class="btn btn-h" @click="$refs.base.hide()">Закрыть
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </base-dialog>
</template>

<script>
import BaseDialog from "../utils/BaseDialog";
import EventBus from "../../event-bus";
import { mapActions } from "vuex";

export default {
    name: "EndSubscriptionDialog",
    components: {BaseDialog},
    data() {
        return {
            subtitle: '',
            text: '',
            count: 1,
            loading: false,
            valid: false,
            customerEmail: '',
            error_message: '',
            emailRules: [
                v => !!v || 'Необходимо указать электронную почту для чека',
                v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Электронная почта неверная'
            ],
        }
    },
    computed: {
        SHOP_PRICE() {
            return 1500;
        }
    },
    methods: {
        ...mapActions('unitpay', {
            unitPay: 'pay'
        }),
        ...mapActions('yookassa', {
            yookassaPay: 'pay'
        }),
        startPay() {

            for (let i in this.emailRules) {
                const rule = this.emailRules[i]
                const rule_result = rule(this.customerEmail)
                if (rule_result !== true) {
                    this.$refs.email.focus()
                    this.error_message = rule_result
                    return
                }
            }

            const vm = this;
            vm.loading = true;
            this.unitPay({customerEmail: vm.customerEmail, count: vm.count})
                .finally(() => {
                    vm.loading = false;
                })
            // this.yookassaPay({customerEmail: vm.customerEmail, count: vm.count})
            //     .finally(() => {
            //         vm.loading = false;
            //     })
        }
    },
    mounted() {
        const vm = this;
        EventBus.$on('end_subscription_dialog', function ({subtitle, text}) {
            vm.text = text;
            vm.subtitle = subtitle;
            if (vm.$refs.base) {
                vm.$refs.base.show();
            }
        })
    }
}
</script>

<style scoped>

</style>